module.exports = __webpack_public_path__ + "5ec77ed202fe28e064ec082160acd65a.gif";